import {DateTime} from "luxon";

function lockedAccountErrorHandler(response, vue) {
    // Generate a timestamp (locked until 1 hour from now by default)
    let lockUntil;

    // If the backend provides a locked_until timestamp, use it
    if (response.body.locked_until) {
        lockUntil = DateTime.fromISO(response.body.locked_until);
    } else {
        // Otherwise, assume locked for 1 hour from now
        lockUntil = DateTime.local().plus({hours: 1});
    }

    // Format the time according to the current locale
    const formattedTime = lockUntil.toFormat('yyyy-MM-dd h:mm a');

    // Display the message with the timestamp
    vue.$showAlertMessage(vue.$t('login.locked_account_error', {time: formattedTime}));
}

export const deviceVerificationErrorHandler = function (response, vue) {
    if (response.status === 401) {
        switch (response.body.msg) {
            case 'wrong_password':
                vue.$showAlertMessage(vue.$t('login.wrong_password'));
                break;
            case 'locked_account_error':
                lockedAccountErrorHandler(response, vue)
                break
            default:
                vue.$showAlertMessage(vue.$t('device_verification.incorrect_code'));
        }
    } else if (typeof response.body === 'object' && 'msg' in response.body) {
        vue.$showAlertMessage(response.body.msg);
    } else {
        vue.$showAlertMessage(vue.$t('error_messages.unknown'));
    }
};

export const loginErrorHandler = function (response, vue) {
    {

        if (response.status === 401) {
            switch (response.body.msg) {
                case 'locked_account_error':
                    lockedAccountErrorHandler(response, vue)
                    break
                case 'disabled_account_error':
                    vue.$showAlertMessage(vue.$t('login.disabled_account_error'));
                    break;
                case 'sasv_not_approved_error':
                    vue.$showAlertMessage(vue.$t('login.sasv_not_approved_error'));
                    break;
                case 'sasv_not_submitted_error':
                    vue.$showAlertMessage(vue.$t('login.sasv_not_submitted_error'));
                    break;
                case 'password_expired_error':
                    vue.$showAlertMessage(vue.$t('login.password_expired_error'));
                    break
                default:
                    vue.$showAlertMessage(vue.$t('login.wrong_password'))
            }
        } else {
            if (response.body.verify_email) {
                vue.$router.push({name: 'email-verify-init'});
            } else if (response.body.verify_device) {
                vue.$router.push({name: 'device-verify', query: {after: vue.$route.query.after, next: vue.next_url}});
            }
        }
    }
}

export const mobileLoginErrorHandler = function(response, vue) {
    if (response.status === 401) {
        switch (response.body.msg) {
            case 'locked_account_error':
                lockedAccountErrorHandler(response, vue)
                break
            case 'disabled_account_error':
                vue.$showAlertMessage(vue.$t('login.disabled_account_error'));
                break;
            case 'sasv_not_approved_error':
                vue.$showAlertMessage(vue.$t('login.sasv_not_approved_error'));
                break;
            case 'sasv_not_submitted_error':
                vue.$showAlertMessage(vue.$t('login.sasv_not_submitted_error'));
                break;
            case 'password_expired_error':
                vue.$showAlertMessage(vue.$t('login.password_expired_error'));
                break
            default:
                vue.$showAlertMessage(vue.$t('login.wrong_password'))
        }
    } else {
        if (response.body.verify_email) {
            vue.$router.push({name: 'mobile-email-verify-init'});
        } else if (response.body.verify_device) {
            vue.$router.push({name: 'mobile-device-verify', query: {after: vue.$route.query.after}});
        }
    }
}

export const adminLoginErrorHandler = function (response, vue) {
    if (response.status === 401) {
        if (response.body.msg === 'locked_account_error') {
            lockedAccountErrorHandler(response, vue)
        } else if (response.body.msg === 'disabled_account_error') {
            vue.$showAlertMessage(vue.$t('login.disabled_account_error'));
        } else {
            vue.$showAlertMessage(vue.$t('login.wrong_password'))
        }
    } else {
        if (typeof response.body === 'object') {
            if (response.body.verify_email) {
                vue.$router.push({name: 'email-verify-init'});
            } else if (response.body.verify_device) {
                vue.$router.push({name: 'admin-device-verify', query: {after: vue.$route.query.after}});
            } else if ('msg' in response.body) {
                vue.$showAlertMessage(response.body.msg);
            } else {
                vue.$showAlertMessage();
            }
        } else {
            vue.$showAlertMessage();
        }
    }
}
